import { Component, OnInit } from '@angular/core';
import { BasicInfoHeaderService } from './basic-info-header.service'
import { CommonUtilitiesService } from '../common-utilities.service';
import { constants } from '../constants';
import { Router } from '@angular/router';

@Component({
  selector: 'app-basic-info-header',
  templateUrl: './basic-info-header.component.html',
  styleUrls: ['./basic-info-header.component.scss']
})
export class BasicInfoHeaderComponent implements OnInit {

  userBasicInfo = {
    name:"",
    linesCount:"",
    location:""
  };
  isLogin:boolean = false
  isBtnDisabled = false;
  pendingTickets = 0;
  isPendingTicketLoading = false;

  constructor(private basicInfoHeaderService: BasicInfoHeaderService, public LANG: CommonUtilitiesService, private _router: Router) { }

  ngOnInit() {

    //se obtiene la infor de sesión
    this.isLogin = !!localStorage.getItem("userData")
    let userData = JSON.parse(localStorage.getItem("userData"));
    this.userBasicInfo.name = userData.name;
    this.userBasicInfo.linesCount = userData.associatedCellPhones.length;
    this.userBasicInfo.location = userData.location;

    this.isPendingTicketLoading = true;
    this.basicInfoHeaderService.getPendingTickets(userData.customerAccountId).subscribe((data => {
      this.isPendingTicketLoading = false;
      if (data['responseCode'] == constants.SUCCESS_WS_RESPONSE_CODE) {
        this.pendingTickets = data['obj'].length;
      }
    }),
    (err) => {
      this.isPendingTicketLoading = false;
      this.pendingTickets = 0;
    });
  }

  /**
   * Description: Método que finaliza la sesión activa de un usuario
   * Autor: Diego Diaz
   * @param N/A
   * @return N/A
   */
  logout(){

    //se obtiene la infor de sesión
    let userData = JSON.parse(localStorage.getItem("userData"));

    this.isBtnDisabled = true;
    this.basicInfoHeaderService.logOut(userData.documentId, userData.token).subscribe((data => {
      //habilitar botones
      this.isBtnDisabled = false;
      localStorage.clear();
      this._router.navigate([constants.ROUTE_URL_LOGIN]);
    }),
    (err) => {
      localStorage.clear();
      this._router.navigate([constants.ROUTE_URL_LOGIN]);
    });    
  }
}
